export default {
    "name": "SOLineItemHistory",
    "kind": "HoudiniQuery",
    "hash": "d77a372c1c642197dcadef6d06bdc823511a7b54b4fde86ac160e1ded41c3970",

    "raw": `query SOLineItemHistory($inventoryId: UInt!, $filter: SalesOrderLineFilter) {
  inventory(id: $inventoryId) {
    allocations {
      salesOrderLines(filter: $filter) {
        items {
          id
          quantity
          price
          salesOrder {
            date
            salesOrderId
            documentType {
              name
              id
            }
            store {
              id
            }
            id
          }
        }
      }
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventory": {
                "type": "Inventory",
                "keyRaw": "inventory(id: $inventoryId)",

                "selection": {
                    "fields": {
                        "allocations": {
                            "type": "InventoryAllocations",
                            "keyRaw": "allocations",

                            "selection": {
                                "fields": {
                                    "salesOrderLines": {
                                        "type": "SalesOrderLineList",
                                        "keyRaw": "salesOrderLines(filter: $filter)",

                                        "selection": {
                                            "fields": {
                                                "items": {
                                                    "type": "SalesOrderLine",
                                                    "keyRaw": "items",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "quantity": {
                                                                "type": "Decimal6",
                                                                "keyRaw": "quantity",
                                                                "visible": true
                                                            },

                                                            "price": {
                                                                "type": "Decimal2",
                                                                "keyRaw": "price",
                                                                "visible": true
                                                            },

                                                            "salesOrder": {
                                                                "type": "SalesOrder",
                                                                "keyRaw": "salesOrder",

                                                                "selection": {
                                                                    "fields": {
                                                                        "date": {
                                                                            "type": "Date",
                                                                            "keyRaw": "date",
                                                                            "visible": true
                                                                        },

                                                                        "salesOrderId": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "salesOrderId",
                                                                            "visible": true
                                                                        },

                                                                        "documentType": {
                                                                            "type": "SalesOrderDocument",
                                                                            "keyRaw": "documentType",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    },

                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "store": {
                                                                            "type": "Store",
                                                                            "keyRaw": "store",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "ID",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "inventoryId": "UInt",
            "filter": "SalesOrderLineFilter"
        },

        "types": {
            "ManufacturerFilter": {
                "code": "String",
                "id": "UInt",
                "inventoryTypeId": "Int",
                "name": "String",
                "vehicle": "Boolean"
            },

            "ModelFilter": {
                "active": "Boolean",
                "id": "UInt",
                "inventoryTypeId": "UInt",
                "manufacturerId": "UInt",
                "name": "String"
            },

            "Decimal2Filter": {
                "eq": "Decimal2",
                "gt": "Decimal2",
                "gte": "Decimal2",
                "lt": "Decimal2",
                "lte": "Decimal2"
            },

            "CustomerFilter": {
                "active": "Boolean",
                "balance": "Decimal2Filter",
                "companyName": "String",
                "contactName": "String",
                "email": "String",
                "ids": "UInt",
                "keyword": "String",
                "phoneNumber": "String"
            },

            "DateFilter": {
                "eq": "Date",
                "gt": "Date",
                "gte": "Date",
                "lt": "Date",
                "lte": "Date",
                "ne": "Date"
            },

            "SalesOrderDocumentTypeFilter": {
                "affectsInventory": "Boolean",
                "id": "UInt",
                "name": "String"
            },

            "SalesOrderKey": {
                "salesOrderId": "UInt",
                "storeId": "UInt"
            },

            "SalesOrderFilter": {
                "counterpersonUserId": "UInt",
                "customerFilter": "CustomerFilter",
                "date": "DateFilter",
                "documentTypeFilter": "SalesOrderDocumentTypeFilter",
                "finalized": "Boolean",
                "ids": "SalesOrderKey",
                "isSale": "Boolean",
                "storeId": "UInt",
                "void": "Boolean"
            },

            "SalesOrderLineFilter": {
                "manufacturer": "ManufacturerFilter",
                "model": "ModelFilter",
                "price": "Decimal2Filter",
                "salesOrderFilter": "SalesOrderFilter",
                "type": "SalesOrderLineType"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=b29d9fc8adaec1e3176192fa702b2967886c5cd35e9028b0b1cc40e6af1a4e93";